import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CommonState, error, isFetching } from '@pec/aion-ui-core/slices/common';
import { enqueueRequestErrorSnackbar } from '@pec/aion-ui-core/actions/enqueueSnackbar';
import { IProcess } from '@pec/aion-ui-core/interfaces/process';

const name = 'contractorAutomations';

export type FetchContractorAutomationsParams = {
  contractorId: string;
  clientOrganizationId: string;
};

export const fetchContractorAutomationsForClient = createAsyncThunk(
  `${name}/fetch`,
  async ({ contractorId, clientOrganizationId }: FetchContractorAutomationsParams, { dispatch }) => {
    try {
      const url = `/api/processautomation/v1.0/contractors/${contractorId}/automations?clientOrganizationId=${clientOrganizationId}`;
      const response = await axios.get<{ value: IProcess[] }>(url);
      return { clientOrganizationId, automations: response.data?.value ?? [] };
    } catch (err) {
      dispatch(enqueueRequestErrorSnackbar());
      throw err;
    }
  }
);

export type State = CommonState & {
  byClientOrganizationId: Record<string, IProcess[]>;
};

const initialState: State = {
  byClientOrganizationId: {},
  isFetching: false,
  error: null
};

const contractorAutomations = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchContractorAutomationsForClient.pending, isFetching)
      .addCase(fetchContractorAutomationsForClient.fulfilled, (state, action) => {
        state.byClientOrganizationId[action.payload.clientOrganizationId] = action.payload.automations;
        state.isFetching = false;
      })
      .addCase(fetchContractorAutomationsForClient.rejected, error);
  }
});

export const { reducer: contractorAutomationsReducer } = contractorAutomations;
